module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label label=$ctrl.teaserTitleLabel></app-widgets-label> <app-i18n-p text=route.teaser_title main-lang=route.main_lang></app-i18n-p> </div> </div> <div class=col-xs-12> <div class=form-group> <app-widgets-label label=$ctrl.teaserLabel></app-widgets-label> <app-i18n-p text=route.teaser main-lang=route.main_lang multiline=true></app-i18n-p> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/general/partial_snowshoe_tour.html
// module id = 506
// module chunks = 0